import { PureComponent } from 'react';
import PropTypes from 'prop-types';
import PropTypesDom from 'prop-types-dom';
import isServer from '@cotyorg/ccx-utils/js/helpers/isServer';
import { CLOSE_START } from '../../modules/status';

const getFocusableElements = el => (
  el.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
);

// Need to use class in order to use lifecycle methods
// to bind and unbind document events
// istanbul ignore next
class ModalKeyListener extends PureComponent {
  componentDidMount() {
    this.currentFocusIndex = -1;
    if (!isServer) {
      document.addEventListener('keydown', this.onDocumentKeydown, false);
      document.addEventListener('keyup', this.onDocumentKeyup, false);
    }
  }

  componentDidUpdate() {
    const { isOpen } = this.props;
    if (!isOpen) {
      this.currentFocusIndex = -1;
    }
  }

  componentWillUnmount() {
    if (!isServer) {
      document.removeEventListener('keydown', this.onDocumentKeydown, false);
      document.removeEventListener('keyup', this.onDocumentKeyup, false);
    }
  }

  onDocumentKeydown = (e) => {
    const { key } = e;
    const { isOpen, setStatus, id } = this.props;

    if (key === 'Shift') {
      this.isShiftKeyDown = true;
    } else if (key === 'Escape' && isOpen) {
      setStatus({ id, status: CLOSE_START });
    } else if (key === 'Tab' && isOpen) {
      // Prevent default tab action and set the focus progammatically in order
      // to keep focus inside the modal - this is recommended by WCAG
      e.preventDefault();
      const newIndex = this.isShiftKeyDown ? this.currentFocusIndex - 1 : this.currentFocusIndex + 1;
      this.changeFocus(newIndex);
    }
  }

  onDocumentKeyup = ({ key }) => {
    if (key === 'Shift') {
      this.isShiftKeyDown = false;
    }
  }

  changeFocus(index) {
    const { wrapper } = this.props;
    const focusable = getFocusableElements(wrapper);
    const newIndex = (index > focusable.length - 1) ? (
      0
    ) : (index < 0) ? (
      focusable.length - 1
    ) : (
      index
    );

    focusable[newIndex].focus();
    this.currentFocusIndex = newIndex;
  }

  render() {
    return null;
  }
}

ModalKeyListener.propTypes = {
  wrapper: PropTypesDom.domNode.isRequired,
  isOpen: PropTypes.bool.isRequired,
  id: PropTypes.string.isRequired,
  setStatus: PropTypes.func.isRequired,
};

export default ModalKeyListener;
